import { useContext, useEffect, useState, useRef } from 'react'
import { IObject, IResponse } from 'interfaces'
import useFetch from 'hooks/useFetch'
import { UserContext, GeneralContext } from 'context'
import { Icon } from 'assets/index'
import { DoclistHandle, InfoCard, Loading, UsersTable, Path } from 'components'
import { Theme } from 'styles/Themes'
import { dateToTimestamp, hasAccess, optionsLevels } from 'helper/utils'
import * as Sessions from 'components/Modal/Items'
import { IMAGES } from 'configs/configs.js'
import { useStorage } from 'hooks'
import { Container } from './style'

export default function DetalhesCaptacao() {
  const { selectedId, loading, setLoading } = useContext(UserContext)
  const { gestor } = useContext(GeneralContext)
  // const specialistList = gestor.get()
  const [data, setData] = useState<any>({})
  const formData = useRef<FormData>(new FormData())
  const [user] = useStorage('User')
  const api = useFetch(`/gestor/captation?id=${selectedId.current}`)
  const [colaboradores] = useStorage('Colaboradores')

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const response: IResponse = await api.fetch('get')
        if (response.fail) throw new Error(response.errors.message)

        const info = response.data.data

        info.attachments = []
        switch (info.holderList.length) {
          case 0:
            info.capType = 'Aberta'
            break
          case 1:
            info.capType = 'Personalizada Individual'
            break
          default:
            info.capType = 'Personalizada em Grupo'
        }
        const now = new Date().getTime()
        const release = dateToTimestamp(info.releaseAt)?.getTime() || 0

        switch (info.status) {
          case 'PRE_LIST':
          case 'ICO':
            info.status = 'Aberta'
            break
          case 'AVAILABLE':
            if (now > release) {
              info.status = 'Rentabilizando'
            } else {
              info.status = 'Em captação'
            }
            break
          case 'FREEZE':
            info.status = 'Pausado'
            break
          case 'CANCELED':
            info.status = 'Cancelado'
            break
          case 'BURNED':
            info.status = 'Concluído'
            break
          default:
            info.status = 'Finalizada'
        }
        info.gestor = gestor
          .get()
          .find((item: any) => item.id === info.gestorId)
        const { enterpriseId } = info
        info.enterprise = await api
          .fetch('get', null, `/gestor/enterprise?id=${enterpriseId}`)
          .then((r: IResponse) => r.data.data)
        ;['contract', 'document'].forEach((type: string) => {
          info.enterprise[`${type}List`]?.forEach((c: IObject) => {
            info.attachments.push({
              name: c.type,
              file: c.file,
              type,
            })
          })
        })

        setData(info)
        setLoading(false)
      } catch (err: any) {
        console.log('err', err)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  if (loading) return <Loading modal />

  return (
    <Container>
      <Path className="path">
        <span className="path">
          {'Gestão de produtos > Captações  > Detalhes da captação'}
        </span>
      </Path>
      <h1 className="detalhes-captacao-title">{data.name}</h1>
      <div className="status-card-captacao">
        <img
          className="status-card-captacao-img"
          src={Icon('lock_open.svg')}
          alt="status icon"
        />
        <span>{data?.status}</span>
      </div>

      <h4 className="detalhes-captacao-subtitle">Detalhes da captação</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('lock_open.svg')} value={data?.capType}>
          Modalidade de captação
        </InfoCard>
        <InfoCard icon={Icon('lock_open.svg')} value={data?.status}>
          Status
        </InfoCard>
        {data?.holderList?.length === 1 && (
          <InfoCard icon={Icon('trophy.svg')} value={data?.holderList[0]?.name}>
            Cliente
          </InfoCard>
        )}
        {/* {data?.holderList?.length > 0 && ( */}
        <InfoCard
          icon={`${IMAGES.URL}/images/${
            colaboradores.find((item: any) => item.id === data?.gestorId)
              ?.profilePic
          }`}
          value={
            colaboradores.find((item: any) => item.id === data?.gestorId)?.name
          }
          pic
          width={250}
        >
          Responsável da Captação
        </InfoCard>
        {/* )} */}
      </div>

      <Sessions.Info token={data} />
      <Sessions.Condition token={data} enterprise={data.enterprise} />
      {data?.holderList?.length > 1 && (
        <UsersTable
          cotasAmount={data?.total}
          data={data?.holderList}
          disableDelete={data?.gestorId !== user.id}
        />
      )}
      <Sessions.Contract token={data.token || data} />
      <Sessions.Rental token={data} />
      <Sessions.Dates token={data} isInvesment={false} />
      {data?.bonus && <Sessions.Bonus data={data?.bonus} />}
      {data?.capType === 'Aberta' && data?.status === 'Em captação' ? (
        <div />
      ) : (
        <Sessions.Payments token={data} name={data?.enterpriseName} />
      )}
      {data?.capType !== 'Aberta' && <Sessions.Simula id={data?.id} />}
      <h4 className="detalhes-captacao-subtitle">Anexos da captação</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          readonly={
            !hasAccess('add-document-captation')
            // !['OWNER', 'DIRECTOR'].includes(optionsLevels[user.level]) ||
            // user?.permission === 'READ'
          }
          documentList={data?.attachments}
          formdata={formData.current}
          onChange={() => {
            api
              .fetch(
                'put',
                formData.current,
                `/gestor/enterprise?id=${data.enterprise.id}`,
                { 'Content-type': 'multipart/form-data' }
              )
              .then(console.log)
          }}
        />
      </div>
    </Container>
  )
}
